import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button,
} from '@mui/material';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  confirmColor?: 'primary' | 'warning' | 'error';
  loading?: boolean;
  /** Disable the confirm button independently of `loading` (e.g. a pre-check blocked the action). */
  confirmDisabled?: boolean;
  /**
   * Portal container for the underlying MUI Dialog. Defaults to `document.body`. Pass the
   * full-screen overlay element when the caller is rendered inside a fixed overlay, or the dialog
   * opens (and freezes) behind it.
   */
  container?: HTMLElement | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  confirmColor = 'warning',
  loading = false,
  confirmDisabled = false,
  container,
  onConfirm,
  onCancel,
}) => (
  <Dialog open={open} onClose={loading ? undefined : onCancel} maxWidth="xs" container={container}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText>{message}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} disabled={loading}>Cancel</Button>
      <Button onClick={onConfirm} variant="contained" color={confirmColor} disabled={loading || confirmDisabled}>
        {confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
);
